<template>
    <div>
        <az-back-button :route="{name: 'licitacaoBusca'}" text="Voltar para listagem"></az-back-button>
        <az-container>
            <licitacao-atualizacao-acoes inserindo></licitacao-atualizacao-acoes>
            <v-form @submit.prevent="inserirLicitacao">
                <div class="az-form-content">
                    <v-container fluid grid-list-xl>
                        <dados-gerais ref="dadosGeraisRef" acao="inserindo" :exibirAno="exibirAno" v-model="licitacao"></dados-gerais>
                        <div class="az-actions-form">
                            <div class="align-left"></div>
                            <div class="align-right">
                                <a class="action-secundary" @click="cancelar">Cancelar</a>
                                <button class="action-primary" type="submit">Salvar</button>
                            </div>
                        </div>
                    </v-container>
                </div>
            </v-form>

            <az-confirm @onConfirm="irParaTelaBuscaLicitacao()" @onDecline="mostrarDialogConfirmarSaida = false"
                        v-if="mostrarDialogConfirmarSaida">
                Existem campos preenchidos que não foram salvos. Tem certeza que deseja sair sem salvar?
            </az-confirm>
        </az-container>
    </div>
</template>

<script>
    import LicitacaoAtualizacaoAcoes from './acoes/LicitacaoAtualizacaoAcoes'
    import DadosGerais from '../commons/DadosGerais'
    import {actionTypes} from '@/commons/constants'
    import validadorDatas from './licitacao-atualizacao-validador-datas'
    import { mapState } from 'vuex'

    export default {
        name: 'LicitacaoNovo',
        components: {DadosGerais, LicitacaoAtualizacaoAcoes},
        $_veeValidate: {
            validator: 'new'
        },
        data() {
            return {
                mostrarDialogConfirmarSaida: false,
                licitacao: {
                    dataIniEnvioProposta: null,
                    dataFimEnvioProposta: null,
                    dataAbertura: null,
                    dataLimiteEsclarecimentoImpugnacao:null,
                    dataPrevisaoPublicacao:null,
                    registroPreco: 'N',
                    mostrarValorReserva: true,
                    modalidade: 'PREGÃO ELETRÔNICO',
                    tipoLicitacao: 'MP',
                    casasDecimais: 2,
                    casasDecimaisQuantidade: 2,
                    modoDisputa: null,
                    tempoFaseLance: null,
                    etapaLanceFinal: null,
                    diferencaMinimaLance: 1,
                    diferencaMinimaLancePercentual: false,
                    numeroConvenio: null,
                    numeroCompra: null,
                    anoInstrumento : null,
                    recursoFederal : false,
                    beneficiosRegionais: [],
                    esclarecimentoImpugnacao: true,
                    inversaoFases: false,
                    anoCompra: new Date().getFullYear(),
                    amparoLegal: null,
                    publicado: false,
                    origem: 'INTERNA',
                    motivoDespublicacao: '---',
                    beneficioRegional: false,
                    regimento: null,
                    ehPerfilComprasBR: true,
                    utilizaMoedaEstrangeira: false
                }
            }
        },
        computed: {
            ...mapState(['parametros']),
            formFoiAlterado() {
                return Object.keys(this.$refs.dadosGeraisRef.fields).some(key => this.$refs.dadosGeraisRef.fields[key].dirty);
            },
            exibirAno() {
                return this.parametros.propriedadesLicitacao.exibirAno
            }
        },
        mounted() {
          this.setarParametrosLicitacao()
        },
        methods: {
            setarParametrosLicitacao(){
              this.licitacao.tempoFaseLance = this.parametros.propriedadesLicitacao.tempoFaseLance
              this.licitacao.etapaLanceFinal = this.parametros.propriedadesLicitacao.etapaLanceFinal
              this.licitacao.ehPerfilComprasBR = this.parametros.propriedadesLicitacao.ehPerfilComprasBR
              this.licitacao.casasDecimais = this.parametros.propriedadesLicitacao.casasDecimaisValor
              this.licitacao.casasDecimaisQuantidade = this.parametros.propriedadesLicitacao.casasDecimaisQuantidade
            },
            cancelar() {
                if (this.formFoiAlterado) {
                    this.confirmarSaidaDaTela()
                } else {
                    this.irParaTelaBuscaLicitacao()
                }
            },
            confirmarSaidaDaTela() {
                this.mostrarDialogConfirmarSaida = true
            },
            async inserirLicitacao() {
                const validado = await this.$validator._base.validateAll()
                if (!validado) {
                    this.mostrarNotificacaoErro('Preencha corretamente os campos obrigatórios.')
                    return
                }
                const validarBeneficioRegionalLocal = this.validarBeneficioRegional()
                if(!validarBeneficioRegionalLocal){
                    this.mostrarNotificacaoErro('Informe os municípios.')
                    return
                }
                const datasValidadas = validadorDatas.validar(this.licitacao)
                if (!datasValidadas.valido) {
                    this.mostrarNotificacaoErro(datasValidadas.mensagem)
                    return
                }
                await this.inserir()
            },
            async inserir() {
                try {
                    this.$store.commit('setLoadingMessage', 'Salvando a nova licitação...')
                    const {id} = await this.$store.dispatch(actionTypes.INSERIR_LICITACAO, this.licitacao)
                    this.mostrarNotificacaoSucessoDefault()
                    this.irParaTelaEdicaoLicitacao(id)
                } catch (e) {
                    this.mostrarNotificacaoErroDefault()
                }
            },
            validarBeneficioRegional(){
              if(this.licitacao.beneficiosRegionais.length === 0 && this.licitacao.beneficioRegional){
                return false
              }
              return true
          },
            irParaTelaEdicaoLicitacao(id) {
                this.$router.replace({name: 'licitacaoAtualizacaoEdital', params: {id}, query: {edicao: true}})
            },
            irParaTelaBuscaLicitacao() {
                this.$router.push({name: 'licitacaoBusca'})
            }
        }
    }
</script>
